import { render, staticRenderFns } from "./TussenStand.vue?vue&type=template&id=afd27728&scoped=true&"
import script from "./TussenStand.vue?vue&type=script&lang=ts&"
export * from "./TussenStand.vue?vue&type=script&lang=ts&"
import style0 from "./TussenStand.vue?vue&type=style&index=0&id=afd27728&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd27728",
  null
  
)

export default component.exports